import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import directoryUserService from "../../services/directoryUserService";
import schoolClassService from "../../services/schoolClassService";

export default function AssignUserModal({
  visible,
  onClose,
  onSaved,
  udid,
  serialNumber,
  registrationId,
  currentUser,
}) {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState("");
  const [applyName, setApplyName] = useState(true);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!visible) return;
    directoryUserService.listDirectoryUsers()
      .then((rows) => setUsers(rows || []))
      .catch(() => setUsers([]));
    setUserId(currentUser?._id || "");
  }, [visible, currentUser]);

  const save = async () => {
    if (!userId) {
      toast.error("Bitte einen Benutzer wählen.");
      return;
    }
    setBusy(true);
    try {
      await schoolClassService.assignUser({
        udid,
        serialNumber,
        registrationId,
        directoryUserId: userId,
        applyDeviceName: applyName,
      });
      toast.success("Benutzer zugewiesen.");
      onSaved?.();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || "Zuweisung fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  const clear = async () => {
    setBusy(true);
    try {
      await schoolClassService.unassignUser({ udid, serialNumber, registrationId });
      toast.success("Benutzerzuweisung entfernt.");
      onSaved?.();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || "Entfernen fehlgeschlagen.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Benutzer zuweisen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <label className="form-label">Gerätebenutzer</label>
        <select
          className="form-select"
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
        >
          <option value="">— wählen —</option>
          {users.map((user) => (
            <option key={user._id} value={user._id}>
              {user.name} ({user.username}) {user.className ? `· ${user.className}` : ""}
            </option>
          ))}
        </select>
        <div className="form-check mt-3">
          <input
            id="applyDeviceName"
            type="checkbox"
            className="form-check-input"
            checked={applyName}
            onChange={(e) => setApplyName(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="applyDeviceName">
            Gerätenamen aus Standort-Vorlage setzen ({"{{UserFullName}}"} usw.)
          </label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {currentUser ? (
          <Button variant="outline-danger" className="me-auto" disabled={busy} onClick={clear}>
            Zuweisung entfernen
          </Button>
        ) : null}
        <Button variant="secondary" onClick={onClose}>Abbrechen</Button>
        <Button variant="primary" disabled={busy || !userId} onClick={save}>Speichern</Button>
      </Modal.Footer>
    </Modal>
  );
}
